const Panel = ({ id = '', title = '', subtitle = '', message = '', urlPath = '', isDisabled = false } = {}) => ({
  id: String(id),
  title: String(title),
  subtitle: String(subtitle),
  message: String(message),
  urlPath: String(urlPath),
  isDisabled: Boolean(isDisabled),
});

export default Panel;

export type PanelProps = ReturnType<typeof Panel>;
